<div class="spinner_container dark-overlay">
  <mat-spinner  [diameter]="50" *ngIf="spinnerService.visibility | async"></mat-spinner>
</div>
